var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.367 9.28007C14.367 11.2601 12.767 12.8601 10.787 12.8601C8.80703 12.8601 7.20703 11.2601 7.20703 9.28007C7.20703 7.30007 8.80703 5.70007 10.787 5.70007C12.767 5.70007 14.367 7.30007 14.367 9.28007Z",
    stroke: "#0308C4",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.785 17.55C14.315 17.55 17.605 15.47 19.895 11.87C20.795 10.46 20.795 8.09 19.895 6.68C17.605 3.08 14.315 1 10.785 1C7.255 1 3.965 3.08 1.675 6.68C0.775 8.09 0.775 10.46 1.675 11.87C3.965 15.47 7.255 17.55 10.785 17.55Z",
    stroke: "#0308C4",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassIcon);
export default __webpack_public_path__ + "static/media/show_pass_icon.69837de26c67c14edacb38646b661d91.svg";
export { ForwardRef as ReactComponent };